// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__14np0","index":"styles_index__1fNUa"};